import { EVENTS } from '@edreamsodigeo/frontend-ancillary-bundle';
import { fareRulesHandlers } from '../../boundaries/fareRules';
const flexibilityBundle = {
  showForceSelection: () => {
    fareRulesHandlers.eventHandler.trigger(EVENTS.SHOW_FORCE_SELECTION);
  },
  loadFarePrice: data => {
    fareRulesHandlers.eventHandler.trigger(EVENTS.LOAD_FARE_PRICE, data);
  }
};
export default flexibilityBundle;